import React, { useEffect, useRef, useState } from 'react'

const DinamicTarea = ({
    valueT,
    description = 'Escribe una descripción...',
    className = 'text-size',
    setValue = (() => { }),
    field = null,
    style = {},
    setCaret = (() => { }),
    id = 'none'
}) => {
    const [tempVal, setTempVal] = useState(valueT ?? "");
    const textareaRef = useRef([]);

    const resetPX = (altura = '1px') => {
        const resetVal = String(altura);
        const lastPosition = resetVal.indexOf('px');

        if (!lastPosition) {
            console.error("No se permite el valor ", lastPosition);
            return altura
        }
        const valFloat = (parseFloat(resetVal.slice(0, lastPosition)) + 20.00).toFixed(2);

        return String(valFloat) + 'px';
    }

    const resizeTextarea = () => {
        if (textareaRef.current) {
            const elementP = textareaRef.current[0];
            textareaRef.current[1].style.height = resetPX(window.getComputedStyle(elementP).height);;  // Resetea su altura para igual al P
        }
    };

    const handleInputChange = (event) => {
        const newValue = event.target.value;

        if (field) setValue((current_val) => ({ ...current_val, [field]: newValue }));
        else setValue(newValue);
    };

    useEffect(() => {
        setTempVal(valueT);
    }, [valueT]);

    useEffect(() => {
        const handleResize = () => resizeTextarea();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='container-textarea'>
            <p className='limit-lines-text ltp' ref={(e) => textareaRef.current[0] = e} style={{ whiteSpace: 'pre-line', color: 'transparent' }}>{tempVal}</p>
            <textarea
                id={id}
                ref={(e) => textareaRef.current[1] = e}
                value={tempVal}
                className={className}
                placeholder={description}
                onChange={handleInputChange}
                onBlur={(event) => setCaret(event.target.selectionStart)}
                style={style}
                onKeyUp={() => resizeTextarea()}
            />
        </div>
    )
}

export default DinamicTarea